import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ClerkProvider, SignedIn, SignedOut } from '@clerk/clerk-react';
import Dashboard from './components/Dashboard';
import LandingPage from './components/landing/LandingPage';
import { TermsOfService, PrivacyPolicy, RefundPolicy } from './components/landing/Legal';
import { OrganizationProvider } from './contexts/OrganizationContext';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
	const [clerkPubKey, setClerkPubKey] = useState('');
	const urlParams = new URLSearchParams(window.location.search);
	const apiKey = urlParams.get('api_key');

	useEffect(() => {
		setClerkPubKey(process.env.REACT_APP_CLERK_PUBLISHABLE_KEY);
	}, []);
	
	if (!clerkPubKey) {
		return <div>Loading...</div>;
	}

	return (
		<ClerkProvider 
			publishableKey={clerkPubKey}
			appearance={{
				elements: {
					organizationSwitcherTrigger: "w-full flex items-center justify-between p-3 text-left bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer",
					organizationPreview: "flex items-center space-x-2",
					organizationSwitcherPopoverCard: "bg-white border border-gray-200 rounded-lg shadow-lg",
					organizationSwitcherPopoverFooter: "border-t border-gray-200 p-2",
				}
			}}
		>
			<BrowserRouter>
				<ScrollToTop />
				<div className="App">
					<Routes>
						{/* Public routes */}
						<Route path="/terms" element={<TermsOfService />} />
						<Route path="/privacy" element={<PrivacyPolicy />} />
						<Route path="/refund" element={<RefundPolicy />} />

						{/* Main app route - handles all authenticated/unauthenticated routing */}
						<Route
							path="/*"
							element={
								(apiKey) ? (
									<OrganizationProvider>
										<Dashboard />
									</OrganizationProvider>
								) : (
									<>
										<SignedIn>
											<OrganizationProvider>
												<Dashboard />
											</OrganizationProvider>
										</SignedIn>
										<SignedOut>
											<LandingPage />
										</SignedOut>
									</>
								)
							}
						/>
					</Routes>
					<Toaster position="top-right" />
				</div>
			</BrowserRouter>
		</ClerkProvider>
	);
}

export default App;
